import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import { createElement } from "@wordpress/element";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Parts of this source were derived and modified from react-color,
 * released under the MIT license.
 *
 * https://github.com/casesandberg/react-color/
 *
 * Copyright (c) 2015 Case Sandberg
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

/**
 * External dependencies
 */
import { noop } from 'lodash';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Component, createRef } from '@wordpress/element';
import { TAB } from '@wordpress/keycodes';
import { pure } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import { calculateAlphaChange } from './utils';
import KeyboardShortcuts from '../keyboard-shortcuts';
export var Alpha = /*#__PURE__*/function (_Component) {
  _inherits(Alpha, _Component);

  var _super = _createSuper(Alpha);

  function Alpha() {
    var _this;

    _classCallCheck(this, Alpha);

    _this = _super.apply(this, arguments);
    _this.container = createRef();
    _this.increase = _this.increase.bind(_assertThisInitialized(_this));
    _this.decrease = _this.decrease.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Alpha, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "increase",
    value: function increase() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.01;
      var _this$props = this.props,
          hsl = _this$props.hsl,
          _this$props$onChange = _this$props.onChange,
          onChange = _this$props$onChange === void 0 ? noop : _this$props$onChange;
      amount = parseInt(amount * 100, 10);
      var change = {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: (parseInt(hsl.a * 100, 10) + amount) / 100,
        source: 'rgb'
      };
      onChange(change);
    }
  }, {
    key: "decrease",
    value: function decrease() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.01;
      var _this$props2 = this.props,
          hsl = _this$props2.hsl,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop : _this$props2$onChange;
      var intValue = parseInt(hsl.a * 100, 10) - parseInt(amount * 100, 10);
      var change = {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a <= amount ? 0 : intValue / 100,
        source: 'rgb'
      };
      onChange(change);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this$props$onChange2 = this.props.onChange,
          onChange = _this$props$onChange2 === void 0 ? noop : _this$props$onChange2;
      var change = calculateAlphaChange(e, this.props, this.container.current);

      if (change) {
        onChange(change, e);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      this.handleChange(e);
      window.addEventListener('mousemove', this.handleChange);
      window.addEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp() {
      this.unbindEventListeners();
    }
  }, {
    key: "preventKeyEvents",
    value: function preventKeyEvents(event) {
      if (event.keyCode === TAB) {
        return;
      }

      event.preventDefault();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var rgbString = "".concat(rgb.r, ",").concat(rgb.g, ",").concat(rgb.b);
      var gradient = {
        background: "linear-gradient(to right, rgba(".concat(rgbString, ", 0) 0%, rgba(").concat(rgbString, ", 1) 100%)")
      };
      var pointerLocation = {
        left: "".concat(rgb.a * 100, "%")
      };
      var shortcuts = {
        up: function up() {
          return _this2.increase();
        },
        right: function right() {
          return _this2.increase();
        },
        'shift+up': function shiftUp() {
          return _this2.increase(0.1);
        },
        'shift+right': function shiftRight() {
          return _this2.increase(0.1);
        },
        pageup: function pageup() {
          return _this2.increase(0.1);
        },
        end: function end() {
          return _this2.increase(1);
        },
        down: function down() {
          return _this2.decrease();
        },
        left: function left() {
          return _this2.decrease();
        },
        'shift+down': function shiftDown() {
          return _this2.decrease(0.1);
        },
        'shift+left': function shiftLeft() {
          return _this2.decrease(0.1);
        },
        pagedown: function pagedown() {
          return _this2.decrease(0.1);
        },
        home: function home() {
          return _this2.decrease(1);
        }
      };
      return createElement(KeyboardShortcuts, {
        shortcuts: shortcuts
      }, createElement("div", {
        className: "components-color-picker__alpha"
      }, createElement("div", {
        className: "components-color-picker__alpha-gradient",
        style: gradient
      }), createElement("div", {
        className: "components-color-picker__alpha-bar",
        ref: this.container,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleChange,
        onTouchStart: this.handleChange
      }, createElement("div", {
        tabIndex: "0",
        role: "slider",
        "aria-valuemax": "1",
        "aria-valuemin": "0",
        "aria-valuenow": rgb.a,
        "aria-orientation": "horizontal",
        "aria-label": __('Alpha value, from 0 (transparent) to 1 (fully opaque).'),
        className: "components-color-picker__alpha-pointer",
        style: pointerLocation,
        onKeyDown: this.preventKeyEvents
      }))));
    }
  }]);

  return Alpha;
}(Component);
export default pure(Alpha);
//# sourceMappingURL=alpha.js.map